<button mat-icon-button class="mat-accent intro-ping" matTooltip="Besoin d'aide ?" matTooltipPosition="before" [matTooltipClass]="class + ' mat-fill'" matTooltipCta="5s"
(mouseenter)="clearPing()" (click)="onClick.next()">
    <mat-icon>question_mark</mat-icon>
</button>